import { render } from "./IntroTable.vue?vue&type=template&id=52b0f940"
import script from "./IntroTable.vue?vue&type=script&lang=js"
export * from "./IntroTable.vue?vue&type=script&lang=js"

import "./IntroTable.vue?vue&type=style&index=0&id=52b0f940&lang=less"

import exportComponent from "D:\\WorkSpace\\Codes\\website-apps\\frontend\\report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__